import domReady from '@wordpress/dom-ready';

domReady(async () => {
	const selector = '.js-block-carousel-heading';
	const elements = document.querySelectorAll(selector);

	if (!elements.length) {
		return;
	}

	const eventName = new CustomEvent('carouselHeadingInit');
	const { CarouselHeadingSlider } = await import('./carousel-heading-slider');

	[...elements].forEach((element) => {
		const carouselHeadingSlider = new CarouselHeadingSlider({
			element,
			blockClass: 'block-carousel-heading',
			nextElement: `${selector}-next`,
			prevElement: `${selector}-prev`,
			eventName,
		});

		carouselHeadingSlider.init();
	});
});
